"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceReadingsChart = DeviceReadingsChart;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var recharts_1 = require("recharts");
var devices_1 = require("../../../constants/devices");
var device_1 = require("../../../features/apis/device");
var api_error_message_1 = require("../../../utils/api-error-message");
var device_metrics_1 = require("../../../utils/device-metrics");
var loader_1 = require("../../loader");
var dropdown_component_1 = require("../../ui/dropdown-component");
var text_component_1 = require("../../ui/text-component");
var chart_card_1 = require("../tasks/chart-card");
function DeviceReadingsChart(props) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var device = props.device, userId = props.userId;
    var RANGES = [
        { value: "24h", label: "Last 24 hours", hours: 24 },
        { value: "7d", label: "Last 7 days", hours: 24 * 7 },
        { value: "30d", label: "Last 30 days", hours: 24 * 30 },
    ];
    var PAGE_SIZE = 500;
    var MAX_LINES_WITHOUT_PICKER = 2;
    var deviceId = device.id;
    var metrics = (0, device_metrics_1.getDeviceMetrics)(device);
    var hasMetricPicker = metrics.length > MAX_LINES_WITHOUT_PICKER;
    var labelOf = function (metric) { var _a, _b; return ((_b = (_a = device.dataPoints) === null || _a === void 0 ? void 0 : _a[metric.key]) === null || _b === void 0 ? void 0 : _b.ignored) ? "".concat(metric.label, " (currently ignored)") : metric.label; };
    var _f = (0, react_1.useState)("24h"), range = _f[0], setRange = _f[1];
    var _g = (0, react_1.useState)((_b = (_a = metrics[0]) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : ""), selectedMetricKey = _g[0], setSelectedMetricKey = _g[1];
    // The chart stays mounted when the page moves to another device, so the stored key may belong
    // to a metric the new device doesn't have. Fall back to the first metric rather than drawing nothing.
    var metricKey = metrics.some(function (metric) { return metric.key === selectedMetricKey; }) ? selectedMetricKey : ((_d = (_c = metrics[0]) === null || _c === void 0 ? void 0 : _c.key) !== null && _d !== void 0 ? _d : "");
    var _h = (0, react_1.useState)([]), readings = _h[0], setReadings = _h[1];
    var _j = (0, react_1.useState)(false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = (0, react_1.useState)(""), error = _k[0], setError = _k[1];
    var _l = (0, react_1.useState)(0), refreshTick = _l[0], setRefreshTick = _l[1];
    var loadedSelectionRef = (0, react_1.useRef)("");
    var fetchReadings = (0, device_1.useLazyGetDeviceReadingsQuery)()[0];
    // Ignoring from a past date or restoring hidden readings changes what the API returns, so the chart reloads straight away.
    var dataPointsVersion = JSON.stringify((_e = device.dataPoints) !== null && _e !== void 0 ? _e : {});
    (0, react_1.useEffect)(function () {
        var timer = window.setInterval(function () { return setRefreshTick(function (currentTick) { return currentTick + 1; }); }, devices_1.DEVICE_SYNC_INTERVAL_MS);
        return function () {
            window.clearInterval(timer);
        };
    }, []);
    // Loads every page for the range, oldest last, then shows them oldest first. A newer range
    // choice cancels the older load so its results can't overwrite the newer ones. The sync tick
    // re-runs the load with a fresh window so new readings appear; it keeps the current chart
    // visible instead of showing the loader again.
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var isCancelled = false;
        var hours = (_b = (_a = RANGES.find(function (option) { return option.value === range; })) === null || _a === void 0 ? void 0 : _a.hours) !== null && _b !== void 0 ? _b : 24;
        var to = new Date();
        var from = new Date(to.getTime() - hours * 60 * 60 * 1000);
        var selection = "".concat(deviceId, "|").concat(userId, "|").concat(range);
        var isSelectionChange = loadedSelectionRef.current !== selection;
        loadedSelectionRef.current = selection;
        var load = function () { return __awaiter(_this, void 0, void 0, function () {
            var collected, before, response, loadError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isSelectionChange) {
                            setIsLoading(true);
                            setError("");
                        }
                        collected = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        _a.label = 2;
                    case 2: return [4 /*yield*/, fetchReadings({ id: deviceId, userId: userId, from: from.toISOString(), to: to.toISOString(), before: before, size: PAGE_SIZE }).unwrap()];
                    case 3:
                        response = _a.sent();
                        if (isCancelled) {
                            return [2 /*return*/];
                        }
                        collected.push.apply(collected, response.content.items);
                        before = response.content.nextBefore;
                        _a.label = 4;
                    case 4:
                        if (before) return [3 /*break*/, 2];
                        _a.label = 5;
                    case 5:
                        setReadings(collected.reverse());
                        setError("");
                        return [3 /*break*/, 8];
                    case 6:
                        loadError_1 = _a.sent();
                        if (!isCancelled && isSelectionChange) {
                            setError((0, api_error_message_1.getApiErrorMessage)(loadError_1, "Unable to load readings."));
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        if (!isCancelled) {
                            setIsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        load();
        return function () {
            isCancelled = true;
        };
    }, [deviceId, userId, range, refreshTick, dataPointsVersion]);
    // Up to two metrics share the chart on separate axes; a device with more gets a picker and one line at a time.
    var shownMetrics = hasMetricPicker ? metrics.filter(function (metric) { return metric.key === metricKey; }) : metrics;
    var series = shownMetrics.map(function (metric, index) { return ({
        key: metric.key,
        label: metric.unit ? "".concat(labelOf(metric), " (").concat(metric.unit, ")") : labelOf(metric),
        color: metric.color,
        axis: index === 0 ? "left" : "right",
    }); });
    var data = readings.map(function (reading) { return (__assign({ time: new Date(reading.readingTime).toLocaleString(undefined, range === "24h" ? { hour: "2-digit", minute: "2-digit" } : { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) }, reading.metrics)); });
    return ((0, jsx_runtime_1.jsxs)(chart_card_1.ChartCard, { title: "Readings", action: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-2", children: [hasMetricPicker && ((0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Reading metric", options: metrics.map(function (metric) { return ({ value: metric.key, label: labelOf(metric) }); }), selectedKey: metricKey, onSelectionChange: setSelectedMetricKey, className: "w-44" })), (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Reading range", options: RANGES, selectedKey: range, onSelectionChange: setRange, className: "w-44" })] }), children: [isLoading && (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "md", label: "Loading readings" }), !isLoading && error && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }), !isLoading && !error && !data.length && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "No readings in this period." }), !isLoading && !error && data.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "h-72 -ml-2", children: (0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, { width: "100%", height: "100%", children: (0, jsx_runtime_1.jsxs)(recharts_1.LineChart, { data: data, margin: { top: 4, right: 8, bottom: 0, left: 0 }, children: [(0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { vertical: false, stroke: "#e1e0d9" }), (0, jsx_runtime_1.jsx)(recharts_1.XAxis, { dataKey: "time", tickLine: false, axisLine: false, tick: { fontSize: 11, fill: "#898781" }, minTickGap: 32 }), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { yAxisId: "left", tickLine: false, axisLine: false, tick: { fontSize: 11, fill: "#898781" }, width: 40 }), series.some(function (line) { return line.axis === "right"; }) && ((0, jsx_runtime_1.jsx)(recharts_1.YAxis, { yAxisId: "right", orientation: "right", tickLine: false, axisLine: false, tick: { fontSize: 11, fill: "#898781" }, width: 32 })), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, {}), series.map(function (line) { return ((0, jsx_runtime_1.jsx)(recharts_1.Line, { yAxisId: line.axis, type: "monotone", dataKey: line.key, name: line.label, stroke: line.color, strokeWidth: 2, dot: false, connectNulls: true }, line.key)); })] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-wrap items-center gap-3", children: series.map(function (line) { return ((0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1.5", children: [(0, jsx_runtime_1.jsx)("span", { className: "size-2 rounded-md", style: { backgroundColor: line.color }, "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "medium-gray", label: line.label })] }, line.key)); }) })] }))] }));
}
